import React, { Component } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Loader from "react-loader";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-awesome-modal";
import Tour from "reactour";
import { calcColor } from "src/common/services";
import withServices from "src/HOCs/withServices";

import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import SwarmPlot from "../../../../components/DataViz/SwarmPlot/SwarmPlot";
import {
  getPerceptions,
  getCohorts,
  updateMultipleVals,
  getCohortsPerceptionData,
  getYearGroups,
} from "../../../../redux/ducks/schoolPerceptions";
import { FabButton } from "../../../Onboard/Common/Common.styles";
import {
  Container,
  Heading,
  Wrapper,
  Row,
  ComponentWrapper,
  Button,
  Description,
} from "./SchoolPerceptions.styles";
import { tourSteps } from "./SchoolPerceptionsTour";
import {
  getCohortsList,
  getUserTypeAssessments,
} from "src/redux/ducks/schoolDataCenter";

import { SOCKET } from "src/common/constants";
import { ModalWrapper } from "../ReportCenter/ReportCenter.styles";
import { pStyles } from "../ReportCenter/ReportCenter.Component";
import { decodeSocketMessage } from "src/common/utils";

interface IProps {
  services?: any;
  history?: any;
  dispatch?: any;
  perceptionsReducer?: any;
  dataCenterReducer?: any;
}
interface IState {
  guidesRead: boolean;
  sid: string | null;
  socketLoading: boolean;
  downloadModal: boolean;
}

class SchoolPerceptions extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      guidesRead: true,
      sid: null,
      socketLoading: false,
      downloadModal: false,
    };
  }

  public async componentDidMount() {
    const {
      services: { isUserLoggedIn },
    } = this.props;
    if (!isUserLoggedIn) {
      this.onLogout();
      return;
    }

    SOCKET.on("connect", () => {
      console.log("connected");
    });
    SOCKET.on("customEmit", (data) => this.onSetup(data));
    SOCKET.on("customNotif", (data) => this.onMessage(data));
    SOCKET.emit("customMsg", { evt: "init" });
  }

  public onMessage(socketResponse) {
    const socketMessage = decodeSocketMessage(socketResponse);
    this.setState({ socketLoading: false });

    if (socketMessage.message.status === "failed") {
      toast.error(
        "Ooops, the report could not be generated: " +
          socketMessage.message.data.final_status
      );
    }
    const link = socketMessage.message.data.link;

    window.open(link, "_blank");
  }

  public onSetup = (message) => {
    this.setState({ sid: message.id });
  };

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}PerceptionsTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };

  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public onLogout = () => {
    this.props.history.replace("/login");
  };

  public currentUserKey = () => {
    const { currentUserType } = this.props.perceptionsReducer;
    if (currentUserType === "students") {
      return "name_students";
    } else {
      return "name_teachers";
    }
  };

  public assignClass = (clicked, current) => {
    if (clicked === +current) {
      return "perception-active active";
    } else {
      return "";
    }
  };

  public toggleGuides = () => {
    const { guidesRead } = this.state;
    if (!this.props.perceptionsReducer.cohortID) {
      toast.info("First pick users and a cohort above");
      return;
    }
    this.setState({ guidesRead: !guidesRead });
  };

  public toggleDownloadModal = () => {
    const { downloadModal } = this.state;
    this.setState({ downloadModal: !downloadModal });
  };

  public perceptionClickHandler = (event) => {
    const selected = event.target.value;
    this.props.dispatch(
      updateMultipleVals({ perceptionsDataLoaded: false, isLoading: true })
    );

    const {
      perceptionsReducer: { cohortID, cohorts, currentUserType, yearGroup },
      dispatch,
    } = this.props;

    if (cohortID === null || cohortID === "") {
      toast.warn("Pick a cohort first!");
    } else {
      const currentCohort = cohorts.find((c) => c.cohort === cohortID);

      dispatch(
        updateMultipleVals({
          selectedPerception: selected,
          perceptionsDataLoaded: false,
          studentCount: currentCohort ? currentCohort.total : 0,
          firstClickDone: true,
        })
      );

      dispatch(
        getCohortsPerceptionData(
          this.props.services.currentUserID,
          currentUserType,
          cohortID,
          selected,
          yearGroup
        )
      );
    }
  };

  public onSelectUserType = (e) => {
    this.props.dispatch(
      updateMultipleVals({
        cohortsLoaded: false,
        perceptionsDataLoaded: false,
        selectedPerception: null,
        cohortID: null,
        currentUserType: e.target.targetVal,
      })
    );
    const {
      services: { institutionsAPI, currentUserID },
      dispatch,
    } = this.props;

    const targetVal = e.target.value;
    if (e.target.value === "") {
      return;
    }

    dispatch(getUserTypeAssessments(currentUserID, e.target.value));
    dispatch(getPerceptions());
    dispatch(getCohorts(currentUserID, targetVal));
    dispatch(getYearGroups(currentUserID));
  };

  public cohortSelectionHandler = (event) => {
    const cohort = event.target.value;
    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}DataCenterTour`
    );
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }
    this.setState({
      // cohortID: cohort,
      // perceptionsDataLoaded: false,
      // selectedPerception: null,
      guidesRead,
    });

    this.props.dispatch(
      updateMultipleVals({
        perceptionsDataLoaded: false,
        cohortID: cohort,
        selectedPerception: null,
      })
    );
    toast.info(
      "You can now select a perception or select a year group/department"
    );
  };

  public yearGroupSelectionHandler = (event) => {
    const yearGroup = event.target.value;

    this.props.dispatch(
      updateMultipleVals({
        yearGroup,
        perceptionsDataLoaded: false,
        selectedPerception: null,
      })
    );
  };

  public onNodeItemClick = (data) => {
    this.props.history.push(`/schools/viewstudentdata/${data.studentId}`);
  };

  public onSelectAssessment = (event) => {
    const selectedAssessment = event.target.value;

    this.props.dispatch(updateMultipleVals({ selectedAssessment }));
    this.props.dispatch(
      getCohortsList(this.props.services.currentUserID, selectedAssessment)
    );
    // this.loadCohort(selectedAssessment);
  };

  public onSelectAssessmentCohort = (e) => {
    console.log("COHORT_ID", e.target.value);
    this.props.dispatch(updateMultipleVals({ selectedCohort: e.target.value }));
  };

  public onDownloadReport = async () => {
    const { selectedAssessment } = this.props.dataCenterReducer;
    const { selectedCohort } = this.props.perceptionsReducer;

    if (!selectedAssessment || !selectedCohort) {
      toast.error(
        "Please make sure you've selected an assessment and a cohort"
      );
      return;
    }
    toast.info("Generating report, please wait...");

    const {
      services: { institutionsAPI },
    } = this.props;

    const res = await institutionsAPI.downloadPerceptionsReport(
      selectedAssessment,
      selectedCohort,
      this.state.sid
    );

    this.setState({ downloadModal: true });
  };

  public renderPickers = () => {
    return (
      <div className="sf-query">
        <div className="show-picker">
          <span>What shall we explore today: &nbsp;</span>
          <span>
            <select
              className="custom-select sf-select"
              onChange={this.onSelectUserType}
              style={{ width: "240px" }}
              defaultValue={this.props.perceptionsReducer.currentUserType}
            >
              <option value=""> -- </option>
              <option value="students">Our Learners </option>
              <option value="teachers">Our Teachers </option>
            </select>
          </span>
        </div>
        {this.renderCohortsPicker()}

        {this.renderYearGroupsPicker()}
      </div>
    );
  };

  public renderCohortsPicker = () => {
    const { cohorts, cohortsLoaded, currentUserType } =
      this.props.perceptionsReducer;
    if (cohortsLoaded) {
      return (
        <div className="show-picker">
          <span>Now, pick a cohort</span>
          <span>
            <select
              name="cohort"
              id="cohort"
              className="custom-select"
              onChange={this.cohortSelectionHandler}
            >
              <option value="">-- Great, Now Pick a Cohort</option>
              {cohorts.map((item) => (
                <option value={item.cohort} key={item.cohort}>
                  {item.cohort} : {item.total} {currentUserType}
                </option>
              ))}
            </select>
          </span>
        </div>
      );
    } else {
      return "";
    }
  };

  public renderYearGroupsPicker = () => {
    const { yearGroups, yearGroupsLoaded } = this.props.perceptionsReducer;
    if (yearGroupsLoaded) {
      return (
        <div className="show-picker">
          <span>Now, pick a year group</span>
          <span>
            <select
              name="yearGroup"
              id="yearGroup"
              className="custom-select"
              onChange={this.yearGroupSelectionHandler}
            >
              <option value="">-- Great, Now Pick a Year Group</option>
              {yearGroups.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </select>
          </span>
        </div>
      );
    } else if (yearGroupsLoaded && !yearGroups.length) {
      return "No year groups available";
    } else {
      return "";
    }
  };

  public renderPerceptionsList = () => {
    const {
      perceptionsList,
      perceptionsListLoaded,
      selectedPerception,
      cohortsLoaded,
      cohortID,
    } = this.props.perceptionsReducer;
    if (perceptionsListLoaded && cohortID) {
      return (
        <React.Fragment>
          {perceptionsList.map((perception) => (
            <Button
              key={perception.name}
              value={perception.id}
              onClick={this.perceptionClickHandler}
              className={this.assignClass(perception.id, selectedPerception)}
            >
              {perception.name}
            </Button>
          ))}
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff2500" />;
    }
  };

  public renderSwarmPlot = () => {
    const {
      perceptionsData,
      perceptionsDataLoaded,
      studentCount,
      cohortsLoaded,
      isLoading,
    } = this.props.perceptionsReducer;

    const groups = new Set();

    // levelCounts = [extreme, high, moderate, low, no]
    const levelCounts = [0, 0, 0, 0, 0];

    if (perceptionsDataLoaded && cohortsLoaded && perceptionsData.length) {
      const graphData = perceptionsData.map((student, i) => {
        groups.add(student.group);
        return {
          id: i,
          group: student.group,
          studentId: student.id,
          studentName: student.name,
          perceptionLevel: Math.round(student.perceptionLevel * 12.5),
        };
      });

      perceptionsData.forEach((student) => {
        const level = Math.round(student.perceptionLevel * 12.5);

        if (level > 0 && level <= 20) {
          levelCounts[0] += 1;
        } else if (level > 20 && level <= 40) {
          levelCounts[1] += 1;
        } else if (level > 40 && level <= 60) {
          levelCounts[2] += 1;
        } else if (level > 60 && level <= 80) {
          levelCounts[3] += 1;
        } else if (level > 80 && level <= 100) {
          levelCounts[4] += 1;
        }
      });

      return (
        <ComponentWrapper className="animated fadeInUp" height="640px">
          <SwarmPlot
            data={graphData}
            groups={Array.from(groups)}
            entries={studentCount}
            onNodeItemClick={this.onNodeItemClick}
          />

          <div className="summary-stats">
            <p className="summary-stat">
              Extremely Urgent Attention Needed:{" "}
              <span style={{ color: calcColor(10) }}>{levelCounts[0]}</span>{" "}
            </p>
            <p className="summary-stat">
              Urgent Attention Needed:{" "}
              <span style={{ color: calcColor(30) }}>{levelCounts[1]}</span>{" "}
            </p>
            <p className="summary-stat">
              Moderate Attention Needed:{" "}
              <span style={{ color: calcColor(50) }}>{levelCounts[2]}</span>{" "}
            </p>
            <p className="summary-stat">
              Low Attention Needed:{" "}
              <span style={{ color: calcColor(70) }}>{levelCounts[3]}</span>{" "}
            </p>
            <p className="summary-stat">
              No Attention Needed:{" "}
              <span style={{ color: calcColor(90) }}>{levelCounts[4]}</span>{" "}
            </p>
          </div>
        </ComponentWrapper>
      );
    } else if (
      perceptionsDataLoaded &&
      cohortsLoaded &&
      !perceptionsData.length
    ) {
      return (
        <ComponentWrapper className="animated fadeInUp" height="60px">
          <Row>
            <Description>No learners fit this category</Description>
          </Row>
        </ComponentWrapper>
      );
    } else {
      return isLoading ? <Loader color="#acff24" /> : "";
    }
  };

  public assessmentPicker() {
    const {
      assessments,
      // showAssessmentPicker,
      currentUserType,
      selectedCohort,
      selectedAssessment,
      cohorts,
    } = this.props.dataCenterReducer;

    return (
      <div className="reports-wrapper">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "#fff",
          }}
          className="reports-query"
        >
          {/* usertype options */}
          <div>
            <span style={{ fontStyle: "italic", textAlign: "center" }}>
              What shall we explore today &nbsp;
            </span>
            {/* <span> */}
            <select
              className="custom-select sf-select"
              onChange={this.onSelectUserType}
              style={{ width: "300px" }}
              defaultValue={currentUserType}
            >
              <option value=""> -- </option>
              <option
                // selected={currentUserType === "students"}
                value="students"
              >
                Our Learners{" "}
              </option>
              <option
                // selected={currentUserType === "teachers"}
                value="teachers"
              >
                Our Teachers{" "}
              </option>
            </select>
            {/* </span> */}
          </div>
          {/* assessment options */}
          {assessments.length && currentUserType.length ? (
            <div>
              <span style={{ fontStyle: "italic", textAlign: "center" }}>
                Choose an assessment to explore{" "}
              </span>
              <select
                className="custom-select"
                onChange={this.onSelectAssessment}
                style={{ width: "300px", marginTop: "0.5em" }}
              >
                <option> -- </option>
                {assessments.map((assessment) => (
                  <option
                    selected={assessment.id === +!selectedAssessment}
                    key={assessment.id}
                    value={assessment.id}
                  >
                    {assessment.name}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            ""
          )}

          {/* Cohorts */}
          {cohorts.length ? (
            <div>
              <span style={{ fontStyle: "italic", textAlign: "center" }}>
                Choose a cohort &nbsp;{" "}
              </span>
              <select
                className="custom-select"
                onChange={this.onSelectAssessmentCohort}
                style={{ width: "300px", marginTop: ".5em" }}
              >
                <option value=""> -- </option>
                {cohorts.map((cohort) => (
                  <option
                    selected={cohort.assessment === selectedCohort}
                    key={cohort.assessment}
                    value={cohort.assessment}
                  >
                    {cohort.assessment}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            ""
          )}

          {/* yeargroups */}
          {/* <div>
            <span style={{ fontStyle: "italic", textAlign: "center" }}>
              Choose a year group (Optional) &nbsp;{" "}
            </span>
            <select
              className="custom-select"
              onChange={this.onSelectYearGroup}
              style={{ width: "300px", marginTop: ".5em" }}
            >
              <option value=""> -- </option>
              {this.state.yearGroups.map((yeargroup) => (
                <option
                  selected={yeargroup === this.state.selectedYearGroup}
                  key={yeargroup}
                  value={yeargroup}
                >
                  {yeargroup}
                </option>
              ))}
            </select>
          </div> */}

          {/* <div style={{display: "flex", alignItems: "center", width: "100%", justifyContent: "space-evenly"}}>
            <span>Regenerate Reports</span>
            <Switch
            checked={this.state.regenerateReport}
            onChange={this.toggleRegenerate}
            offColor="#ff0033"
            onColor="#75db00"
            offHandleColor="#fff"
            aria-labelledby="switch-label"
            checkedIcon={false}
            uncheckedIcon={false}
          />
          </div> */}

          <button
            onClick={this.onDownloadReport}
            style={{ marginTop: "1em", padding: ".5em 3em" }}
            className="green-button download-report"
          >
            Download Now
          </button>
        </div>
      </div>
    );
  }

  public render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <ToastContainer />
        <Modal
          height="400"
          width="400"
          visible={this.state.downloadModal}
          effect="fadeInDown"
          onClickAway={this.toggleDownloadModal}
        >
          <ModalWrapper>
            <i
              className="fa fa-times-circle-o close-report-modal"
              aria-hidden="true"
              onClick={this.toggleDownloadModal}
            />
            {this.assessmentPicker()}
          </ModalWrapper>
        </Modal>

        <Navbar logoutParent={this.onLogout} />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        <Container>
          <Row>
            <Heading>Your Perceptions Performance</Heading>
            <Description>
              Please choose a cohort and perception you'd like to explore
            </Description>
          </Row>
          <Row>{this.renderPickers()}</Row>
          <Wrapper className="step-1">{this.renderPerceptionsList()}</Wrapper>
          <Row>
            {this.props.perceptionsReducer.firstClickDone
              ? this.renderSwarmPlot()
              : ""}
          </Row>
        </Container>
        <FabButton
          right="8px"
          bottom="25px"
          bgColor="#1a1a1a"
          onClick={this.toggleGuides}
        >
          <p className="fab-text">Need a hand</p>
          <i
            className="fa fa-question"
            style={{ fontSize: "30px", color: "#ff0033" }}
          />
        </FabButton>
        <FabButton
          right="8px"
          bottom="130px"
          bgColor="#1a1a1a"
          onClick={this.toggleDownloadModal}
        >
          <p className="fab-text">Download Report</p>
          <i
            className="fa fa-file"
            style={{ fontSize: "18px", color: "#acff24" }}
          />
        </FabButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    perceptionsReducer: state.schoolPerceptionsReducer,
    dataCenterReducer: state.schoolDCReducer,
  };
};

export default connect(mapStateToProps)(withServices(SchoolPerceptions));



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ViewPerceptions/SchoolPerceptions.Component.tsx